import React from 'react';
import { Box, FormHelperText } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import EditableField from './EditableField';
const msgs = defineMessages({
    errorRequired: {
        id: 'form.ValidatableField.error.required',
        defaultMessage: 'This field is required.',
    },
    errorRequiredShort: {
        id: 'form.ValidatableField.error.requiredShort',
        defaultMessage: 'Required',
    },
    errorMaxLength: {
        id: 'form.ValidatableField.error.maxLength',
        defaultMessage: 'This field can contain up to {value} characters.',
    },
    errorMaxLengthShort: {
        id: 'form.ValidatableField.error.maxLengthShort',
        defaultMessage: 'Max {value} chars',
    },
    errorMaxValue: {
        id: 'form.ValidatableField.error.maxValue',
        defaultMessage: 'This field should be smaller than {value}.',
    },
    errorMaxValueShort: {
        id: 'form.ValidatableField.error.maxValueShort',
        defaultMessage: 'Max {value}',
    },
    errorMinValue: {
        id: 'form.ValidatableField.error.minValue',
        defaultMessage: 'This field should be larger than {value}.',
    },
    errorMinValueShort: {
        id: 'form.ValidatableField.error.minValueShort',
        defaultMessage: 'Min {value}',
    },
    errorPatern: {
        id: 'form.ValidatableField.error.patern',
        defaultMessage: 'Invalid format',
    },
    errorPaternShort: {
        id: 'form.ValidatableField.error.paternShort',
        defaultMessage: 'Invalid format',
    },
});
function ErrorHelperText({ errorInline, message }) {
    return (React.createElement(FormHelperText, { error: true, sx: errorInline
            ? { position: 'absolute', top: 0, lineHeight: '0.6rem', fontSize: '0.6rem', pointerEvents: 'none', mx: 0 }
            : undefined }, message));
}
const ValidatableField = ({ id = 'name', errors, helperTexts, register, registerOptions, shortMessage, errorInline, ...props }) => {
    const intl = useIntl();
    return (React.createElement(Box, { sx: { position: 'relative' } },
        React.createElement(EditableField, { error: !!errors[id], ...register(id, registerOptions), ...props }),
        helperTexts
            ? helperTexts.map((e, i) => (React.createElement(FormHelperText, { key: i, sx: { mx: 0 } }, e)))
            : null,
        errors[id]?.type === 'required' ? (React.createElement(ErrorHelperText, { errorInline: errorInline, message: intl.formatMessage(shortMessage ? msgs.errorRequiredShort : msgs.errorRequired) })) : null,
        errors[id]?.type === 'maxLength' ? (React.createElement(ErrorHelperText, { errorInline: errorInline, message: intl.formatMessage(shortMessage ? msgs.errorMaxLengthShort : msgs.errorMaxLength, {
                value: registerOptions?.maxLength?.toString() || 0,
            }) })) : null,
        errors[id]?.type === 'max' ? (React.createElement(ErrorHelperText, { errorInline: errorInline, message: intl.formatMessage(shortMessage ? msgs.errorMaxValueShort : msgs.errorMaxValue, {
                value: registerOptions?.max?.toString() || 0,
            }) })) : null,
        errors[id]?.type === 'min' ? (React.createElement(ErrorHelperText, { errorInline: errorInline, message: intl.formatMessage(shortMessage ? msgs.errorMinValueShort : msgs.errorMinValue, {
                value: registerOptions?.min?.toString() || 0,
            }) })) : null,
        errors[id]?.type === 'pattern' ? (React.createElement(ErrorHelperText, { errorInline: errorInline, message: intl.formatMessage(shortMessage ? msgs.errorPaternShort : msgs.errorPatern) })) : null));
};
export default ValidatableField;
